import { render, staticRenderFns } from "./BuildUsageCodeDetail.vue?vue&type=template&id=d96b290c&scoped=true"
import script from "./BuildUsageCodeDetail.vue?vue&type=script&lang=js"
export * from "./BuildUsageCodeDetail.vue?vue&type=script&lang=js"
import style0 from "./BuildUsageCodeDetail.vue?vue&type=style&index=0&id=d96b290c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96b290c",
  null
  
)

export default component.exports